export default __webpack_public_path__ + "static/media/safe-icon.01b2ffbd.png";